import { render, staticRenderFns } from "./AnalyzeBranch.vue?vue&type=template&id=2706fb2a&scoped=true&"
import script from "./AnalyzeBranch.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeBranch.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeBranch.vue?vue&type=style&index=0&id=2706fb2a&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeBranch.vue?vue&type=style&index=1&id=2706fb2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706fb2a",
  null
  
)

export default component.exports